import Vue from 'vue';
import transferTransformer from './../../transformers/transfer';
import store from './../../store';

const success = (resolve, response) => {
  store.dispatch('RefreshStockProducts');
  resolve(response.data);
};

const failed = (errors, reject) => {
  if (errors.error) {
    reject(errors.error);
    return;
  } else if (errors.message) {
    reject(errors);
    return;
  }

  reject(transferTransformer.fetch(errors));
};

export default transfer => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('/transfers', transfer)
      .then((response) => {
        success(resolve, response);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/transfer/store.js